import React from 'react';
import ReactDOM from 'react-dom';
import { PulseLoader } from 'react-spinners';

const LoadingModal = ({ active, text = 'Loading...' }) => {
    if (!active) return null;

    return ReactDOM.createPortal(
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                zIndex: 9999, // Way above MUI dialogs
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                color: '#fff',
                fontSize: '1.2rem',
            }}
        >
            <PulseLoader color="#ffffff" />
            <div style={{ marginTop: '1rem' }}>{text}</div>
        </div>,
        document.body
    );
};

export default LoadingModal;
